import { useTranslation } from 'react-i18next';
import DashboardLayout from '@/components/feature/DashboardLayout';
import OreeMarketView from './components/OreeMarketView';

export default function TradingOverviewPage() {
  const { t } = useTranslation();
  return (
    <DashboardLayout>
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">{t('trading_overview_title')}</h1>
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t('trading_overview_subtitle')}</div>
      </div>
      <OreeMarketView marketFilter={null} />
    </DashboardLayout>
  );
}
